import { render } from "./SalonDetail.vue?vue&type=template&id=2ff9daf1&scoped=true"
import script from "./SalonDetail.vue?vue&type=script&lang=js"
export * from "./SalonDetail.vue?vue&type=script&lang=js"

import "./SalonDetail.vue?vue&type=style&index=0&id=2ff9daf1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ff9daf1"]])

export default __exports__